export default __webpack_public_path__ + "static/media/Innovator-Vignette.2dea9f67.pdf";